export default __webpack_public_path__ + "media/images/icons/new-facebook-8d2f2808583052d4ea428994a324bca4.svg";